"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useTranslate = require("./useTranslate");
Object.keys(_useTranslate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useTranslate[key];
    }
  });
});
var _enUS = require("./en-US.js");
Object.keys(_enUS).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _enUS[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _enUS[key];
    }
  });
});